/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

import { webApi } from '../../lib/WebApi'

export const validateGame = (team, game, uploads, ignoreErrors) => {
    var uploadCount = Object.keys(uploads).length
    return new Promise((resolve, reject) => {
        console.log('before createOpp')
        createOpp(game, game.away_team.title)
            .then((game) => {
                console.log('after createOpp')
                return checkGame(game, uploads, ignoreErrors)
            })
            .then(game => {
                console.log('after checkGame')
                return checkUpdateGame(game, uploadCount)
            })
            .then(game => {
                console.log('after checkUpdateGame')
                return checkGetPreviousGameDate(game)
            })
            .then((prevGameDate) => {
                console.log('after checkGetPreviousGameDate', prevGameDate)
                return checkSensors(game, ignoreErrors)
            })
            .then(() => {
                console.log('after checkSensors')
                return checkCoachNotes(team, game)
            })
            .then(() => {
                console.log('after checkCoachNotes')
                return checkCameraSync(team, game)
            })
            .then(() => {
                console.log('after checkCameraSync')
                console.log('validation passed')
                resolve(true)
            })
            .catch(err => {
                console.log('validation failed', err)
                reject(err)
            })
    })
}

function dateFromString(val, mo = 1) {
    var str = val != null ? val : '1970-01-01 00:00:00'
    var parts = str.split(' ')
    var date = new Date(0)
    if (parts.length === 2) {
        var dateParts = parts[0].split('-')
        var timeParts = parts[1].split(':')
        if (dateParts.length === 3 && timeParts.length >= 2) {
            var y = parseInt(dateParts[0], 10)
            var m = parseInt(dateParts[1], 10) - mo
            var d = parseInt(dateParts[2], 10)
            var hh = parseInt(timeParts[0], 10)
            var mm = parseInt(timeParts[1], 10)
            date = new Date(y, m, d, hh, mm)
        }
    }
    return date
}

function checkGame(game, uploads, ignoreErrors)  {
    return new Promise((resolve, reject) => {
        // case id
        if (game.pi_id.length === 0) {
            reject('missing_case_id')
        }

        // away team
        if (game.away_team == null ||
            game.away_team.title == null ||
            game.away_team.title.length < 1) {
            if (ignoreErrors.indexOf('missing_opponent') < 0) {
                reject('missing_opponent')
            }
        }

        // game time, in the past
        var date = dateFromString(game.date + ' ' + game.approx_start_time)
        var min = new Date(2018, 0, 1, 1)
        var now = new Date()
        if (!date || date > now || date < min) {
            reject('invalid_game_time')
            return
        }

        // video files
        var keys = Object.keys(uploads)
        if (keys.length === 0 && game.camera_type === 'regular') {
            reject('no_video_files')
            return
        }

        // Score
        if (parseInt(game.away_team.score, 10) === 0 && parseInt(game.home_team.score, 10) === 0) {
            if (ignoreErrors.indexOf('score_warning') < 0) {
                reject('score_warning')
                return
            }
        }
        
        // Colors
        if (game.away_team.jersey_color === ''  ||
            game.home_team.jersey_color === '') {
            if (ignoreErrors.indexOf('colors_warning') < 0) {
                reject('colors_warning')
                return
            }
        }

        resolve(game)
    })
}

function createOpp(game) {
    return new Promise((resolve, reject) => {
        if ((game.away_team.team_id == null || game.away_team.team_id <= 0) && game.away_team.title != null && game.away_team.title.length > 1) {
            webApi.createTeam(game.away_team.title)
                .then(team => {
                    game.away_team.name = team.team_name
                    game.away_team.team_id = team.team_id
                    resolve(game)
                })
                .catch(err => {
                    console.log(err)
                    resolve(game)
                })
        } else {
            resolve(game)
        }
    })
}

function checkGetPreviousGameDate(game) {
    return new Promise((resolve, reject) => {
        webApi.getGames()
            .then(games => {
                if (games) {
                    var date = '1970-01-01'
                    for (var i in games) {
                        var g = games[i]
                        if (g.date > date && g.game_id !== game.game_id) {
                            date = g.date
                        }
                    }
                    resolve(date)
                } else {
                    reject('missing_games')
                }
            })
            .catch(err => {
                console.log(err)
                reject(err)
            })
    })
}

function checkSensors(game, ignoreErrors) {
    return new Promise((resolve, reject) => {
        if (game.camera_type === 'trace') {
            resolve(true)
            return
        }
        webApi.checkForSensorData(game.game_id)
            .then((files) => {
                console.log('checkSensors:', files)
                if (files.length <= 0) {
                    if (ignoreErrors.indexOf('sensors') < 0) {
                        reject('sensors')
                        return
                    }
                }
                resolve(true)
            })
            .catch((err) => {
                if (ignoreErrors.indexOf('sensors') < 0) {
                    reject('sensors')
                }
            })
    })
}







function checkCoachNotes(team, game) {
    return new Promise((resolve, reject) => {
        var teamId = team.name
        var start = dateFromString(game.date + ' ' + game.approx_start_time)
        var dur = game.approx_half_duration
        var gameFolder = game.home_team.s3_sources.split('/').pop()
        webApi.checkCoachNotes(teamId, start, dur, gameFolder)
            .then(json => {
                resolve(true)
            })
            .catch(err => {
                resolve(true)
            })
    })
}

function checkCameraSync(team, game) {
    return new Promise((resolve, reject) => {
        var teamId = team.name
        var start = dateFromString(game.date + ' ' + game.approx_start_time)
        var dur = game.approx_half_duration
        var gameFolder = game.home_team.s3_sources.split('/').pop()
        webApi.checkCameraSync(teamId, start, dur, gameFolder)
            .then(json => {
                console.log('CheckCameraSync json', json)
                if (json.check === true) {
                    resolve(true)
                } else {
                    reject('camera_sync')
                }
            })
            .catch(err => {
                console.log('CheckCameraSync error', err)
                reject('camera_sync')
            })
    })
}

function checkUpdateGame(game, uploadCount) {
    return new Promise((resolve, reject) => {
        webApi.updateGame(game, uploadCount)
            .then(json => {
                resolve(game)
            })
            .catch(err => {
                reject(err)
            })
    })
}



